<h2 mat-dialog-title>
  {{ data.id ? 'Edit Resource Type' : 'Add Resource Type' }}
</h2>
<form (ngSubmit)="onSubmit()" #typeForm="ngForm" autocomplete="off">
  <mat-dialog-content>
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Name</mat-label>
      <input matInput name="name" [(ngModel)]="data.name" required #nameInput="ngModel" />
      <mat-error *ngIf="nameInput.invalid && nameInput.touched">Name is required</mat-error>
    </mat-form-field>
    <div style="width: 100%; margin-top: 1rem;">
      <label style="font-size: 0.95rem; font-weight: 500; color: #666; margin-bottom: 0.25rem; display: block;">
        Icon <span style="color: #f44336;">*</span>
      </label>
      <input
        class="icon-search-input"
        type="text"
        placeholder="Search icons..."
        [(ngModel)]="iconSearch"
        name="iconSearch"
        autocomplete="off"
      />
      <div class="icon-grid" style="margin-bottom: 0.5rem;">
        <button
          mat-button
          type="button"
          *ngFor="let icon of filteredIcons"
          (click)="data.icon = icon; typeForm.form.markAsDirty();"
          [ngClass]="{'selected': data.icon === icon, 'icon-centered': true}"
          [attr.aria-label]="icon"
        >
          <mat-icon style="margin: 0 auto; display: block;">{{ icon }}</mat-icon>
        </button>
      </div>
      <div *ngIf="!data.icon && typeForm.submitted" style="color: #f44336; font-size: 12px; margin-top: 4px;">
        Icon is required - please select an icon
      </div>
    </div>
    
    <div style="width: 100%; margin-top: 1rem;">
      <mat-checkbox
        [(ngModel)]="data.allowMultiple"
        name="allowMultiple"
        style="margin-bottom: 1rem;">
        Allow multiple resources of this type per session
      </mat-checkbox>

      <mat-form-field
        *ngIf="data.allowMultiple"
        appearance="outline"
        style="width: 100%;">
        <mat-label>Max Concurrent Resources (optional)</mat-label>
        <input
          matInput
          type="number"
          min="1"
          [(ngModel)]="data.maxConcurrent"
          name="maxConcurrent"
          placeholder="Leave empty for unlimited" />
        <mat-hint>Maximum number of resources that can be used simultaneously</mat-hint>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close type="button">Cancel</button>
    <button
      mat-flat-button
      color="primary"
      type="submit"
      [disabled]="!data.name || !data.icon"
    >
      Save
    </button>
  </mat-dialog-actions>
</form>
